import { AwsRum as OriginalAwsRum, AwsRumConfig } from 'aws-rum-web';
import { ENVIRONMENT } from '../constants/env-constants';
import { RumEvent } from './analytics/rum';

const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'us-east-2';

class FakeAwsRum {
  recordEvent(eventType: string, eventAttributes: object) {
    console.log('FakeAwsRum:recordEvent:(NOT TRACKING)', eventType, eventAttributes);
  }
}

let awsRum: OriginalAwsRum | null = null;

export const initializeAwsRum = (): void => {
  if (!ENVIRONMENT.AWS_CLOUDWATCH_APPLICATION_ID) {
    console.log('initializeAwsRum: ENVIRONMENT.AWS_CLOUDWATCH_APPLICATION_ID is required');
    return;
  }

  if (!ENVIRONMENT.AWS_CLOUDWATCH_IDENTITY_POOL_ID) {
    console.log('initializeAwsRum: ENVIRONMENT.AWS_CLOUDWATCH_IDENTITY_POOL_ID is required');
    return;
  }

  const config: AwsRumConfig = {
    sessionSampleRate: 0.1,
    identityPoolId: ENVIRONMENT.AWS_CLOUDWATCH_IDENTITY_POOL_ID,
    endpoint: 'https://dataplane.rum.us-east-2.amazonaws.com',
    telemetries: ['errors', 'http'],
    // telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: true,
    releaseId: process.env['AWS_COMMIT_ID'] || 'local-dev',
  };

  try {
    awsRum = new OriginalAwsRum(
      ENVIRONMENT.AWS_CLOUDWATCH_APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );
    awsRum.recordEvent('AppLoaded', {});
  } catch (error) {
    console.log('initializeAwsRum:Error initializing AWS RUM', error);
    // throw error;
  }
};

class AwsRum extends OriginalAwsRum {
  // Extend AwsRum.recordEvent to receive RumEvent as eventType
  recordEvent(eventType: RumEvent, eventData: object) {
    super.recordEvent(eventType, eventData);
  }
}

export const getAwsRum = (): AwsRum => {
  if (!awsRum) {
    initializeAwsRum();
  }
  if (!awsRum) return new FakeAwsRum() as AwsRum;
  return awsRum;
};
